import dayjs from 'dayjs';

export const calculateAgeAtDate = (dateOfBirth: string, targetDate: string): number => {
  const birth = dayjs(dateOfBirth);
  const target = dayjs(targetDate);
  return target.diff(birth, 'year');
};

export const calculateDateFromAge = (dateOfBirth: string, targetAge: number): string => {
  const birth = dayjs(dateOfBirth);
  const targetDate = birth.add(targetAge, 'year');
  return targetDate.format('YYYY-MM-DD');
};
